import api from './axios';

// Authentication
export const login = async (username, password) => {
  const response = await api.post('/auth/login', { username, password });
  return response.data;
};

export const register = async (email, password, name) => {
  const response = await api.post('/auth/register', { email, password, name });
  return response.data;
};

// Menu
export const getMenuCategories = async () => {
  const response = await api.get('/menu/categories');
  return response.data;
};

export const getMenuItem = async (itemId) => {
  const response = await api.get(`/menu/items/${itemId}`);
  return response.data;
};

export const createMenuItem = async (itemData) => {
  const response = await api.post('/menu/items', itemData);
  return response.data;
};

export const updateMenuItem = async (itemId, itemData) => {
  const response = await api.put(`/menu/items/${itemId}`, itemData);
  return response.data;
};

export const deleteMenuItem = async (itemId) => {
  const response = await api.delete(`/menu/items/${itemId}`);
  return response.data;
};

// Upload
export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};